import React, { useEffect, useState } from 'react';
import SelectDocumentType from '../..//../components/Selects/SelectDocumentType';
import { textStyles } from '../..//../constants/textStyles';
import Button from '../..//../components/Button/Button';
import DocsInputNew from '../..//../components/Inputs/DocsInput/DocsInputNew';
import Loader from '../..//../components/Loader/Loader';
import LoaderInline from '../../../components/Loader/LoaderInline';
import {
  DEAL_STATUS_CONTRACT_SIGNED,
  DEAL_STATUS_DOCUMENTS_PROCESSING,
  DEAL_STATUS_WAITING_FOR_PAYMENT,
  DEAL_STEPS,
  DOCUMENT_STATUS_SIGNED,
  DOCUMENT_TYPES_CONTRACT,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_OPTIONS,
  DOCUMENT_TYPES_TECH_PASSPORT,
  PAYMENT_STATUS_PAID,
  PAYMENT_TYPES_PREPAYMENT_CARD,
  PAYMENT_TYPES_PREPAYMENT_INVOICE,
} from '../../../constants';
import SelectDealPaymentStatuses from '../../../components/Selects/selectDealPaymentStatuses';
import alert from '../../../helpers/alert';
import editDeal from '../../../api/deals/editDeal';
import { socket } from '../../../App';
import setStep from '../../../api/deals/setStep';
import generateAllowedDocumentsJson from '../../../utils/generateAllowedDocumentsJson';
import generateContract from '../../../api/deals/generateContract';
import { isConsignmentDeal } from './bankFirstStep';

const DealCreatePayment = ({
  onSubmit,
  documents,
  deal,
  title = 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
  setDocumentsForm,
  update,
  backHandler,
  cars,
}) => {
  const row = () => [
    {
      component: SelectDocumentType,
      name: 'fileTypeId',
      style: {
        width: '100%',
      },
      disabled: true,
      defaultValue: DOCUMENT_TYPES_OPTIONS?.find((i) => i.value === DOCUMENT_TYPES_CONTRACT),
    },
    {
      component: DocsInputNew,
      name: 'file',
      label: 'Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
      text: 'Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
      id: Math.random(),
      rules: {
        required: true,
      },
    },
  ];
  const [form, setForm] = useState([row()]);
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingSignButton, setLoadingSignButton] = useState(false);
  const [loadingPaymentButton, setLoadingPaymentButton] = useState(false);

  useEffect(() => {
    if (setDocumentsForm) {
      const fields = form.map((i) => i.map((i) => i.value?.value || i.value));
      setDocumentsForm(
        fields.map((field) => ({
          dealId: deal?.id,
          fileTypeId: field[0],
          file: field[1],
        }))
      );
    }
  }, [form, setDocumentsForm, deal?.id]);

  const updatePaymentStatus = (status) => {
    setLoading(true);

    const isContractSigned = documents?.find(
      (i) => i?.typeId === DOCUMENT_TYPES_CONTRACT && i?.statusId === DOCUMENT_STATUS_SIGNED
    );
    let newStatus = DEAL_STATUS_DOCUMENTS_PROCESSING;

    if (status === PAYMENT_STATUS_PAID) {
      // Ð´Ð»Ñ ÐºÐµÐ¹ÑÐ¾Ð² Ñ Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ¾Ð¼ Ð½Ð° ÑÐ°Ð³ Ð½Ð°Ð·Ð°Ð´
      // ÐµÑÐ»Ð¸ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ ÑÐ¶Ðµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½ - ÑÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸ "ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½", Ð° Ð½Ðµ Ð¿ÑÐ¾Ð¼ÐµÐ¶ÑÑÐ¾ÑÐ½ÑÐ¹ "ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð¾Ð±ÑÐ°Ð±Ð°ÑÑÐ²Ð°ÑÑÑÑ"
      newStatus = isContractSigned ? DEAL_STATUS_CONTRACT_SIGNED : DEAL_STATUS_DOCUMENTS_PROCESSING;
    } else {
      newStatus = DEAL_STATUS_WAITING_FOR_PAYMENT;
    }

    editDeal({
      dealId: deal?.id,
      id: deal?.id,
      statusPaymentId: status,
      clientId: deal?.client?.id,
      paymentTypeId: deal?.paymentType?.id,
      statusId: newStatus,
      ...deal,
      ...generateAllowedDocumentsJson(deal?.paymentType?.id == PAYMENT_TYPES_PREPAYMENT_INVOICE ? [DOCUMENT_TYPES_INVOICE, DOCUMENT_TYPES_CONTRACT, DOCUMENT_TYPES_TECH_PASSPORT] : [DOCUMENT_TYPES_CONTRACT, DOCUMENT_TYPES_TECH_PASSPORT]),
    })
      .then(async () => {
        alert.success('Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½');
        if (status === PAYMENT_STATUS_PAID) {
          // await generateContract({orderIds: cars?.map(i => i?.orderId)})
          setStep({
            dealId: deal?.id,
            // ÐÐ¾ÑÑÑÐµÐ½Ð¸Ðµ: ÑÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð½ÑÐ¶ÐµÐ½ Ð¸ Ð±ÐµÐ· ÐºÑÐµÐ´Ð¸ÑÐ° â Ð¾Ð½ Ð²ÑÑÐ°ÑÑ
            // Ð¼ÐµÐ¶Ð´Ñ Ð¾Ð¿Ð»Ð°ÑÐ¾Ð¹ Ð¸ ÐÐÐ, Ð° Ð´Ð°Ð»ÑÑÐµ ÑÐ°Ð³ 5 Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð°ÐµÑÑÑ ÐºÐ°Ðº Ð¾Ð±ÑÑÐ½Ð¾.
            step: isConsignmentDeal(cars) ? DEAL_STEPS.TRIPARTITE_CONTRACT : 5,
          })
            .then(() => {
              update && update();
            })
            .catch(() => {
              alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
            });
        }

        update && update();
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const isDealPaid = deal?.statusPayment?.id === PAYMENT_STATUS_PAID;
  const [paymentStatus, setPaymentStatus] = useState(null);

  const sendPaymentSms = () => {
    setLoadingPaymentButton(true);
    editDeal({
      dealId: deal?.id,
      id: deal?.id,
      paymentTypeId: PAYMENT_TYPES_PREPAYMENT_CARD,
      statusId: deal?.status?.id,
      ...generateAllowedDocumentsJson(deal?.paymentType?.id == PAYMENT_TYPES_PREPAYMENT_INVOICE ? [DOCUMENT_TYPES_INVOICE, DOCUMENT_TYPES_CONTRACT, DOCUMENT_TYPES_TECH_PASSPORT] : [DOCUMENT_TYPES_CONTRACT, DOCUMENT_TYPES_TECH_PASSPORT]),
      generatePaymentLink: true,
      ...deal,
    })
      .then(() => {
        alert.success('Ð¡ÐÐ¡ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾');
      })
      .catch(() => {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð¡ÐÐ¡');
      })
      .finally(() => {
        setLoadingPaymentButton(false);
      });
  };

  useEffect(() => {
    const contract = documents?.find((i) => i?.typeId === DOCUMENT_TYPES_CONTRACT);
    socket.on('listenSignatureAgreementDocumentInDeal' + contract?.id, (data) => {
      if (data?.success) {
        update && update();
      } else {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°');
      }
    });

    return () => {
      socket.off('listenSignatureAgreementDocumentInDeal' + contract?.id);
    };
  }, [documents, update]);

  useEffect(() => {
    console.log('listenCreditCardPaymentChunk' + deal?.chunkId);
    socket.on('listenCreditCardPaymentChunk' + deal?.chunkId, (data) => {
      if (data?.success) {
        update && update();
      } else {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð¿Ð»Ð°ÑÑ');
      }
    });

    return () => {
      socket.off('listenCreditCardPaymentChunk' + deal?.chunkId);
    };
  }, [deal?.chunkId, update]);

  if (loading) {
    return (
      <div style={{ padding: '10px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0' }}>
        <LoaderInline />
      </div>
    );
  }

  return (
    <>
      {loadingPage ? (
        <Loader />
      ) : (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', columnGap: '20px', marginTop: 20, marginBottom: 20 }}>
            <p style={textStyles.formTitle}>{title}</p>
          </div>
          <div style={{ marginBottom: 40 }}>
            {documents?.map((document) => (
              <a
                href={document?.url}
                target="_blank"
                style={{
                  gap: 7,
                  display: 'grid',
                  gridTemplateColumns: 'auto 1fr',
                  alignItems: 'center',
                  marginBottom: 20,
                }}
                rel="noreferrer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                  <path
                    d="M2 16H18V9H20V17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V9H2V16ZM12 6H17L10 13L3 6H8V0H12V6Z"
                    fill="var(--brand-primary)"
                  />
                </svg>
                <a style={{ color: 'var(--brand-primary)', fontSize: 16, fontWeight: 400 }}>
                  {document?.type?.title} - {document?.url?.split('/')?.pop()}
                </a>
                {/* <ButtonDelete /> */}
              </a>
            ))}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
            <SelectDealPaymentStatuses label="Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ" onChange={setPaymentStatus} />
          </div>

          {/* {deal?.statusPayment?.id == PAYMENT_STATUS_PAID && <p>ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð½Ð¾ÑÐ°ÑÐ¸Ð°Ð»ÑÐ½ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²</p>} */}

          <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
            <Button text="Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ" fill onClick={() => updatePaymentStatus(paymentStatus?.value)} />
            {backHandler && backHandler()}
          </div>

          {deal?.paymentType?.id === PAYMENT_TYPES_PREPAYMENT_CARD && (
            <>
              <div
                style={{ display: 'flex', alignItems: 'center', columnGap: '20px', marginTop: 20, marginBottom: 20 }}
              >
                <p style={textStyles.formTitle}>ÐÐ¿Ð»Ð°ÑÐ° ÑÑÐµÑÐ° on-line</p>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <Button text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÐ¼Ñ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ" fill onClick={sendPaymentSms} />
                <div
                  style={{
                    border: '1px solid #6A6A6A',
                    textTransform: 'uppercase',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    ...textStyles.fieldLabel,
                  }}
                >
                  {deal?.statusPayment?.title}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default DealCreatePayment;
